// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"5245":"e39e66de0c9459fc","8197":"1eacd36019377ac0","8966":"38c6bb15662a3968"}[chunkId] + ".css";
};